<template>
  <div class="indexPageBox">
    <div class="bannerBox1">
      <HeaderCom></HeaderCom>
      <div style="height: 520px">
        <div class="banner_item" style="background-image: url('static/image/tm_banner.png');">
          <div class="banner_item1_content">
            <p>“四定原则”运管通系统</p>
            <p class="txt1">
              过"四定"原则——定时间、定地点、定人员和定内容，解决管
              廊维护管理中遇到的问题
            </p>
            <div class="item1_infoBox tm_btnColor">
              立即申请
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part1Box">
      <div class="part1_content">
        <div class="part1_header">
          <span>方案简介</span>
          <span>“四定”原则——定时间、定地点、定人员和定内容</span>
          <span class="part1_header_txt3">利用物联网技术、建立视频监控、无限独立式（烟雾报警器、燃气探测器、电气火灾探测器、水压探测器等）物联传感设备、手动报警设置、广播系统，通过NB-IOT、lora、4g、wifi等通信手段实时探测传感设备的运行及报警情况，并借助于移动互联网技术将报警消息（真实警情、未及时处理、误报）推送给各级责任人，并记录处置过程，形成警情处置闭环</span>
        </div>
        <div class="part1_section">
          <div class="part1_center_item">
            解决管廊维护管理中的管廊台账、管线信息、巡线检查、缺陷和隐患处理、检维修和施工管理等管廊维护管理问题
          </div>
          <div class="part1_other_item part1_other_space1">
            <span class="part1_other_txt1">物联网</span>
            <img src="static/image/Internet.png" alt="">
          </div>
          <div class="part1_other_item1 part1_other_space3">
            <span class="part1_other_txt2">移动互联网</span>
            <img src="static/image/Internet.png" alt="">
          </div>
          <div class="part1_other_item1 part1_other_space4">
            <img src="static/image/time.png" alt="">
            <span class="part1_other_txt2">定时间</span>
          </div>
          <div class="part1_other_item1 part1_other_space5">
            <span class="part1_other_txt2">移动定位</span>
            <img src="static/image/location.png" alt="">
          </div>
          <div class="part1_other_item1 part1_other_space6">
            <img src="static/image/place.png" alt="">
            <span class="part1_other_txt2">定地点</span>
          </div>
          <div class="part1_other_item1 part1_other_space7">
            <span class="part1_other_txt2">二维码</span>
            <img src="static/image/QR_code.png" alt="">
          </div>
          <div class="part1_other_item1 part1_other_space8">
            <img src="static/image/person.png" alt="">
            <span class="part1_other_txt2">定人员</span>
          </div>
          <div class="part1_other_item part1_other_space2">
            <img src="static/image/content.png" alt="">
            <span class="part1_other_txt1">定内容</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part2Box">
      <div class="part2_content">
        <div class="part2_header">
          <span class="part2_header_txt1">应用场景</span>
          <span class="part2_header_txt2">“四定”原则——定时间、定地点、定人员和定内容</span>
        </div>
        <div>
          <span class="part2_header_txt3">园区管委会管廊管理、城市综合管廊管理、管线管理、水务公司</span>
        </div>
        <div class="part2_bg1">
          <img src="static/image/scene.png" alt="">
        </div>
      </div>
    </div>
    <div class="part3Box">
      <div class="part3_content">
        <div class="part2_header">
          <span class="part2_header_txt1">解决方案</span>
          <span class="part2_header_txt2">“四定”原则——定时间、定地点、定人员和定内容</span>
        </div>
        <div>
          <span class="part2_header_txt3">管廊管理、管道巡检、设备检维修、作业管控、管廊台帐，管廊地图、管道、管柱信息管理、管道截面管理车巡管理、检修管理、隐患单、记录查询、统计分析等功能。</span>
        </div>
        <div class="part2_bg1">
          <img src="static/image/programme.png" alt="">
        </div>
        <div class="part2_bg1 part2_bg1_space">
          <img src="static/image/Statistics.png" alt="">
        </div>
        <div class="part3_txt1">
          <p>巡检统计：筛选、查询、导出</p>
          <p>为地下管道/管廊施工质量监管提供信息化、可视化监管手段，采用手机+定位+状态地图管理方式，对施工单位可实时上报质量进度、质量记录、变更记录对监理单位可实时审核质量进度、质量情况、变更情况发现问题及时发整改通知书；对业主单位进行可视化管理，实时监督、实时审核。</p>
        </div>
      </div>
    </div>
    <div class="part3Box">
      <div class="part3_content">
        <div class="part2_header">
          <span class="part2_header_txt1">系统界面</span>
          <span class="part2_header_txt2">“四定”原则——定时间、定地点、定人员和定内容</span>
        </div>
        <div class="part2_bg1">
          <img src="static/image/Interface.png" alt="">
        </div>
        <div class="part3_txt1">
          <p></p>
          <p>管廊列表：依据管廊管理的建设标准将管廊信息通过管理后台录入系统，相应权限人员可在手机端、PC端实时查看管廊台账信息，支持管廊台账编辑和删除。</p>
        </div>
      </div>
    </div>
    <div class="part3Box">
      <div class="part3_content">
        <div class="part2_header">
          <span class="part2_header_txt1">客户案例</span>
          <span class="part2_header_txt2">“四定”原则——定时间、定地点、定人员和定内容</span>
        </div>
        <div>
          <span class="part2_header_txt3">南京化工园公用管廊总长约为50公里，管廊上布设有大量蒸汽、工艺管线和电缆桥架，由于区域大，管线长，难以监管，为确保管廊安全，需要对管廊全线化工园公用管廊总长约为50公里，管廊上布设有大量蒸汽、工艺管线和电桥架，由于区域大，管线长，难以监管，为确保管廊安全，需要对管廊全线进行信息化维护管理。南京化工园区目前管廊维护人员共20人，设计MP巡查点87个，检査内容271项，毎日工作记录258条通过引入智慧管理运维管理系统，南京化工园区管理管理公司整体工作效率提升30％，隐患排查及时率提升100％，处理时效提升50％以上，为园区管廊安全管理提供了先进的技术保障手段管网建设及运行，物业小区管理、资产出租、农贸市场管理，还有未移交道路管养、河道保洁等等。嘉兴市嘉诚建设发展有限公司嘉兴市嘉城防屋拆迁有限公司嘉兴市天然气管网建设管理有限公司</span>
        </div>
        <div class="part2_bg1">
          <img src="static/image/case.png" alt="">
        </div>
        <div class="part2_bg1">
          <img src="static/image/Park.png" alt="">
        </div>
      </div>
    </div>
    <RegisterCom></RegisterCom>
    <FooterCom></FooterCom>
  </div>
</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
  import RegisterCom from "../common/registerCom"
  export default {
    name: "transportManage",
    components: {HeaderCom, FooterCom,RegisterCom},
    data(){
      return{
        isActive:1,
        resultList:[
          {
            normalSrc:"static/image/fp_part5_bg1.png",
            txt1:"数据中心",
            txt2:["消管通子系统","其他子系统","数据抽取、缓存","数据清洗、转换","加载到数据中心"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/fp_part5_bg2.png",
            txt1:"防火信息",
            txt2:["社会单位","九小场所","老旧小区/城中村","火灾高危区域","人员密集场所"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/fp_part5_bg3.png",
            txt1:"隐患情报",
            txt2:["火灾隐患分类","火灾隐患分级","火灾隐患名单","火灾隐患黑名单"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/fp_part5_bg4.png",
            txt1:"防火调度",
            txt2:["自动调度","人工调度","专项行动","跨系度调度"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/fp_part5_bg5.png",
            txt1:"专项行动指挥",
            txt2:["专项行动计划","专项行动命令","双向视频指挥","跨系度指挥","结果反馈"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/fp_part5_bg6.png",
            txt1:"综合管理",
            txt2:["一张图监控","一张图指挥","系统设置","对接参数设置","其他系统对接"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
        ],
        part6List:[
          {
            normalSrc:"static/image/fp_part6_bg1.png",
            txt1:"打造全网智慧消防通道",
            txt2:"国内首家具备智慧消防全套解决方案的厂家",
          },
          {
            normalSrc:"static/image/fp_part6_bg2.png",
            txt1:"大数据管控",
            txt2:"大数据、一张图，实现各个系统火灾防控信息的大数据汇聚，隐患分析‘防火调度和专项行动指挥，形成完善的火灾隐患闭环体系，实现城市火灾防控的大数据管控",
          },{
            normalSrc:"static/image/fp_part6_bg3.png",
            txt1:"双向调度指挥",
            txt2:"可以与各火灾防控系统对接实现反向调度指挥，形成双向闭环的业务链系统",
          },{
            normalSrc:"static/image/fp_part6_bg4.png",
            txt1:"AI智能语音识别",
            txt2:"人工智能语音识别进行查询和指挥调度",
          },{
            normalSrc:"static/image/fp_part6_bg5.png",
            txt1:"用户体验极佳",
            txt2:"多年与消防总队、支队、大队业务交流及探索，站在客户角度进行产品规划及系统设计",
          },{
            normalSrc:"static/image/fp_part6_bg6.png",
            txt1:"行业专业素养",
            txt2:"三十年消防行业积累沉淀，深入了解监管部门、使用部门具体业务需求，落地能力强",
          },
        ]

      }
    },
    methods: {
      handleClick(index) {
        this.isActive = index;
      },
      addActive(e,index){
        this.resultList[index].normalSrc = "static/image/fp_part5_bg"+(index+1)+"Active.png";
        this.resultList[index].bgColor = "part5_item2_info part5_item2_infoActive";
        this.resultList[index].txt1Class = "part5_item2_txt1 part5_item2_txt1Active";
        this.resultList[index].txt2Class = "part5_item2_txt2 part5_item2_txt2Active";
      },
      removeActive(e,index){
        this.resultList[index].normalSrc = "static/image/fp_part5_bg"+(index+1)+".png";
        this.resultList[index].bgColor = "part5_item2_info";
        this.resultList[index].txt1Class = "part5_item2_txt1";
        this.resultList[index].txt2Class = "part5_item2_txt2";
      },
    }
  }
</script>

<style scoped>
  @import  '../../assets/css/bannerCom.css';
  .tm_btnColor{
    background:rgba(33,85,179,1);
  }
  .part1Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }
  .part1_content{
    width: 1200px;
    box-sizing: border-box;
    padding: 60px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .part1_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part1_header>span:nth-of-type(1){
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header>span:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 30px 0 50px 0;
  }
  .part1_section{
    width: 755px;
    height: 655px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .part1_center_item{
    width:320px;
    height:320px;
    background:rgba(229,236,255,1);
    border-radius:50%;
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:35px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 20px;
  }
  .part1_other_item{
    display: flex;
    flex-direction: column;
    position: absolute;
    align-items: center;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part1_other_item1{
    display: flex;
    position: absolute;
    align-items: center;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part1_other_space1{
    top: 0;
  }
  .part1_other_space1{
    box-sizing: border-box;
  }
  .part1_other_space2{
    bottom: 0;
  }
  .part1_other_space3{
    top: 125px;
    left: 64px;
  }
  .part1_other_space4{
    top: 125px;
    right: 77px;
  }
  .part1_other_space5{
    top: 299px;
    left: 24px;
  }
  .part1_other_space6{
    top: 299px;
    right: 24px;
  }
  .part1_other_space7{
    bottom: 89px;
    left: 118px;
  }
  .part1_other_space8{
    bottom: 89px;
    right: 118px;
  }
  .part1_other_txt1{
    padding: 5px 0;
  }
  .part1_other_txt2{
    padding:0 10px;
  }
  .part1_header_txt3{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 0 0 30px 0;
  }
  .part2Box{
    width:100%;
    background:rgba(238,242,254,1);
    display: flex;
    justify-content: center;
  }
  .part2_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
  .part2_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 65px 0 0 0;
    flex-direction: column;
    align-items: center;
  }
  .part2_bg1{
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding:10px 0 35px 0;
  }
  .part2_bg1_space{
    padding: 10px 0 0 0;
  }
  .part2_header_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part2_header_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 20px 0 55px 0;
  }
  .part2_header_txt3{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 0 30px 0 0;
  }
  .part3Box{
    width: 100%;
    display: flex;
    justify-content: center;
    background: #ffffff;
  }
  .part3_content{
    width: 1200px;
    box-sizing: border-box;
    padding:0 0 60px 0;
  }
  .part3_txt1{
    display: flex;
    flex-direction: column;
    align-items: center;

  }
  .part3_txt1>p:nth-of-type(1){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,1);
    line-height:30px;
    text-align: center;
  }
  .part3_txt1>p:nth-of-type(2){
    width:1002px;
    height:78px;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part4Box{
    width: 100%;
    display: flex;
    justify-content: center;
    background:rgba(238,242,254,1);
  }
  .part4_content{
    width: 1200px;
    height: 400px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 90px 0 0 0;
  }
  .part4_content_item{
    width: 220px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .part4_content_item>div:nth-of-type(1)>img{
    display: inline-block;
    width: 100px;
    height: 100px;
  }
  .part4_content_item>div:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:26px;
    box-sizing: border-box;
    padding:0 0 25px 0;
  }
  .part4_content_item>div:nth-of-type(3){
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:26px;
  }
  .part5Box{
    width: 100%;
    height: 650px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background:#ffffff;
  }
  .part5_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part5_content_btn{
    width:280px;
    height:60px;
    background:rgba(42,98,255,1);
    border-radius:5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .part5_content_item{
    width: 1000px;
    height: 58px;
    border-bottom:1px solid rgba(227,227,227,1);
    border-radius:1px;
  }
  .part5_content_item>div{
    width: 50%;
    height: 100%;
    border-right:1px solid rgba(227,227,227,1);
    border-radius:1px;
  }
  .part5_content_item1{
    width: 1000px;
    height: 48px;
    box-sizing: border-box;
    display: flex;
    border-right:1px solid rgba(227,227,227,1);
    border-left:1px solid rgba(227,227,227,1);
  }
  .part5_content_item1>div{
    flex: 1;
  }
  .part5_content_item2{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .part5_item2_info{
    width:180px;
    height:300px;
    background:rgba(240,240,240,1);
    border-radius:5px;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    padding: 30px 0 0 0;
    cursor: pointer;
  }
  .part5_item2_infoActive{
    background: #2A62FF;
  }
  .part5_item2_txt1{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(42,98,255,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part5_item2_txt1Active{
    color: #FFFF00;
  }
  .part5_item2_txt2{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:30px;
  }
  .part5_item2_txt2Active{
    color: #FFFFFF;
  }
  .part5_content_border{
    border-right:1px solid rgba(227,227,227,1);
    border-left:1px solid rgba(227,227,227,1);
  }
  .part5_box2_txtInfo>div{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .part5_box2_txtInfo>div>span{
    font-size:12px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(195,206,234,1);
    line-height:22px;
  }
  .part6Box{
    width: 100%;
    height: 700px;
    background:rgba(7,30,94,1);
    display: flex;
    justify-content: center;
  }
  .part6_content{
    width: 1200px;
    height: 100%;
  }
  .part6_header{
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .part6_header>span:nth-of-type(1){
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(255,255,255,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 78px 0 0 0;
  }
  .part6_header>span:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:30px;
    padding: 20px 0 55px 0;
  }
  .part6_content_item{
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .part6_item_box{
    width:380px;
    height:180px;
    background:rgba(255,255,255,1);
    box-sizing: border-box;
    padding: 18px 58px 0 58px;
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 30px 0;
  }
  .part6_info1{
    width: 50px;
    box-sizing: border-box;
    padding: 5px 5px 0 0;
  }
  .part6_info1 img{
    display: inline-block;
  }
  .part6_info2{
    flex: 1;
  }
  .part6_info2>p:nth-of-type(1){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:30px;
  }
  .part6_info2>p:nth-of-type(2){
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(153,153,153,1);
    line-height:22px;
    box-sizing: border-box;
    padding: 10px 0 0 0;
  }
</style>




// WEBPACK FOOTER //
// src/components/info/transportManage.vue